<template lang="pug">
.sv-menu(
  v-click-outside="() => close(false)"
)
    .sv-menu__container(
        @click="toggleShow"
    )
        SvIcon.sv-menu__icon(
            icon="menu"
            :width="25"
            :height="16"
        )

    transition(
      name="menu"
    )
      .sv-menu__dropdown(
          v-show="isOpen"
      )
          SvButton.sv-menu__button(
              view="secondary"
              text="Удалить"
              :prependIcon=`{
                  icon: 'remove',
                  width: 24,
                  height: 24,
                  hover: '#1993EB',
                  default: '#B7BAC6'
              }`
              @click="remove"
          )

          SvButton.sv-menu__button(
              view="secondary"
              text="Копировать"
              :prependIcon=`{
                  icon: 'copy',
                  width: 24,
                  height: 24,
                  hover: '#1993EB',
                  default: '#B7BAC6'
              }`
              @click="copy"
          )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';
import SvIcon from '@/components/uikit/SvIcon.vue';
import vClickOutside from 'v-click-outside';

export default {
  name: 'SvMenu',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleShow() {
      this.isOpen = !this.isOpen;
    },

    close () {
      this.$nextTick(() => {
        if (this.isOpen) this.toggleShow();
      });
    },

    remove() {
      this.$emit('remove');
    },

    copy() {
      this.$emit('copy');
    },
  },

  components: {
    SvIcon,
    SvButton,
  },
};
</script>

<style lang="scss" scoped>
.sv-menu {
    position: relative;

    &__container {
        cursor: pointer;
    }

    &__dropdown {
        position: absolute;
        right: 40px;
        display: flex;
        align-items: center;
        top: -16px;
        box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
        background-color: #fff;
        border-radius: 6px;
        padding: 5px 10px;
    }

    &__dropdown:after {
        content: '';
        box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
        width: 12px;
        height: 12px;
        position: absolute;
        right: -5px;
        top: 19px;
        z-index: 0;
        background-color: white;
        transform: rotate(45deg);
    }
}

.menu-enter-active, .menu-leave-active {
  transition: opacity .3s ease-in-out, transform .3s ease-in-out;
}
.menu-enter, .menu-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
</style>
